import { render } from "./AddRfqItemForm.vue?vue&type=template&id=5788f176"
import script from "./AddRfqItemForm.vue?vue&type=script&lang=js"
export * from "./AddRfqItemForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__